module.exports = __webpack_public_path__ + "static/media/areas01.4548ab3f.jpg";